import Modal from '../../mini/Modal'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { PolicyModalStyles } from './styled'
import { hideModal, showModal } from '../../../actions/_modal'
import PropTypes from 'prop-types'
import { getPolicies } from './API'
import { PoliciesH1, TabsHeader } from '../../Policies/_Styled'
import Policy from '../../Policies/Policy'
import CloseSVG from 'static/images/icons/Close.svg'

const OurPoliciesModal = ({ response, token }) => {

  const dispatch = useDispatch()
  const [policies, setPolicies] = useState([])
  const [activeTab, setActiveTab] = useState('privacy-policy')
  const [isFetchingPolicies, setIsFetchingPolicies] = useState(false)

  useEffect(async () => {
    setIsFetchingPolicies(true)
    const { policies } = await getPolicies(token)
    setPolicies(policies)
    setIsFetchingPolicies(false)
  }, [])

  const handleX = () => {
    dispatch(hideModal())
    dispatch(showModal('CREATE_GUARDIAN_ACCOUNT', { response, token }))
  }

  const onTabHeaderClick = e => {
    setActiveTab(e.currentTarget.getAttribute('data-slug'))
  }

  return (
    <Modal
      width={801}
      top={50}
      height={724}
      background={"#243646"}
      borderRadius={"16px"}
      overflowY={'scroll'}
    >
      <PolicyModalStyles>
        <div className="policies-container accepted">
          {isFetchingPolicies ? (
            <div className="loading-container">
              <div className='loading'/>
            </div>
          ) : (
            <div>
              <div className="container-header">
                <div className="header-inner">
                  <PoliciesH1 className="policy-header">
                    Our Policies
                    <img alt="close button" src={CloseSVG} className="close-button" onClick={handleX} />
                  </PoliciesH1>
                  <ul id="policyTabsHeader">
                    {policies.map(p =>
                      <TabsHeader
                        key={p.id}
                        data-slug={p.slug}
                        onClick={(e) => onTabHeaderClick(e)}
                        selected={activeTab === p.slug}>
                        <span>{p.name}</span>
                      </TabsHeader>
                    )}
                  </ul>
                </div>
              </div>
              <ul id="policyTabs" className="container-body">
                {policies.map(p =>
                  <Policy
                    key={p.id}
                    policy={p}
                    show={activeTab === p.slug} />
                )}
              </ul>
            </div>
          )}
        </div>
      </PolicyModalStyles>
    </Modal>
  )
}

OurPoliciesModal.propTypes = {
  token: PropTypes.string.isRequired,
  response: PropTypes.object.isRequired
}

export default OurPoliciesModal
